import { createAction } from '@reduxjs/toolkit';
import * as c from './constants';
import type { TaskInput } from '@/services/tasks';

export const loadTasks = createAction(c.LOAD_TASKS, (stage?: string) => ({
  payload: { stage },
}));

export const loadTasksSuccess = createAction(
  c.LOAD_TASKS_SUCCESS,
  (tasks: any[]) => ({ payload: { tasks } })
);

export const loadTasksError = createAction(c.LOAD_TASKS_ERROR, (error: string) => ({
  payload: { error },
}));

export const createTaskRequest = createAction('tasks/CREATE_TASK_REQUEST', (input: TaskInput) => ({
  payload: { input },
}));

export const updateTaskRequest = createAction(
  'tasks/UPDATE_TASK_REQUEST',
  (id: number | string, input: Partial<TaskInput>) => ({
    payload: { id, input },
  })
);

export const transitionTaskRequest = createAction(
  'tasks/TRANSITION_TASK_REQUEST',
  (id: number | string, toStage: string, note?: string, driveUrl?: string, hours?: number) => ({
    payload: { id, toStage, note, driveUrl, hours },
  })
);

export const addNoteRequest = createAction(
  'tasks/ADD_NOTE_REQUEST',
  (id: number | string, note: string, driveUrl?: string) => ({
    payload: { id, note, driveUrl },
  })
);

export const logHoursRequest = createAction(
  'tasks/LOG_HOURS_REQUEST',
  (id: number | string, team: string, hours: number, note?: string) => ({
    payload: { id, team, hours, note },
  })
);

export const loadSummary = createAction(c.LOAD_SUMMARY);

export const loadSummarySuccess = createAction(
  c.LOAD_SUMMARY_SUCCESS,
  (summary: any) => ({ payload: { summary } })
);
